import { render, staticRenderFns } from "./pharmaandonco.vue?vue&type=template&id=b5d36302&scoped=true&"
import script from "./pharmaandonco.vue?vue&type=script&lang=ts&"
export * from "./pharmaandonco.vue?vue&type=script&lang=ts&"
import style0 from "./pharmaandonco.vue?vue&type=style&index=0&id=b5d36302&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5d36302",
  null
  
)

export default component.exports